import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteWorkingHoursFormModal from 'src/features/workingHours/components/form/DeleteWorkingHoursFormModal';
import UpdateWorkingHoursFormModal from 'src/features/workingHours/components/form/UpdateWorkingHoursFormModal';
import { workingHoursMessages } from 'src/features/workingHours/utils/messages';
import { WorkingHours } from 'src/features/workingHours/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellWorkingHoursActions({ row }: CellContext<WorkingHours, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateWorkingHoursFormModal
                        selectedWorkingHours={row.original}
                        semantics={{ entryName: formatMessage(workingHoursMessages.workingHours).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateWorkingHoursFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteWorkingHoursFormModal
                        selectedWorkingHours={row.original}
                        semantics={{ entryName: formatMessage(workingHoursMessages.workingHours).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteWorkingHoursFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
